export const headStartQuestionBank = ["kb008@seznam.cz", "paperchow1212@gmail.com"]